import { Fallback } from './Fallback';
import { Skeleton } from '../Skeleton';
import { createLocators } from '@u1/locators';
import React from 'react';
import useStyles from './Avatar.styles';
export interface IAvatarProps {
  /**
   * Image source
   */
  source?: string;
  /**
   * Short name which will be showed in case of broken/empty source
   */
  initials?: string;
  /**
   * Avatar size, px
   */
  size?: number;
  /**
   * Renders fallback image instead of initials if image load was unsuccessful
   */
  fallback?: boolean;
}

export const avatarLocators = createLocators({
  name: 'Avatar',
  componentLocators: ['image', 'initials'],
});
const { locators } = avatarLocators();

const Avatar: React.FC<IAvatarProps> = ({
  initials,
  source,
  fallback,
  size = 52,
}) => {
  const classes = useStyles({ size });
  const [hasError, setHasError] = React.useState(false);
  const [isLoaded, setIsLoaded] = React.useState(false);

  return source && !hasError ? (
    <Skeleton active={!isLoaded && !hasError} round>
      <img
        {...locators.image()}
        src={source}
        className={classes.img}
        loading="lazy"
        decoding="async"
        style={{ width: size, height: size }}
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
      />
    </Skeleton>
  ) : fallback ? (
    <Fallback className={classes.fallback} size={size} />
  ) : (
    <div
      {...locators.initials()}
      style={{ width: size, height: size }}
      className={classes.placeholder}
    >
      {initials}
    </div>
  );
};

export default Avatar;
